<template>
    <div>
        <template v-for="input in editableInputs" :key="input.id">
            <custom-form-input v-if="isVisible(input)" :color="color" :data="input" :disabled="disabled" :edit="edit" v-model="data[input.id].value" :rules="rules"/>
        </template>
    </div>
</template>

<script>
import FormInputsMixin from "../FormInputsMixin";
    import {isString} from "@spoferan/spoferan-ts-core";
    import {parseForInputType} from "@spoferan/spoferan-ts-core";

    export default {
        name: 'CustomFormInputs',


        mixins: [FormInputsMixin],

        props: {

            // The custom inputs to fill
            inputs: {
                type: Array,
                required: true
            },

            color: {
                type: String,
                default: null
            },

            // Whether to apply validation rules on the inputs
            rules: {
                type: Boolean,
                default: true
            },

            // Whether to display the inputs with the 'for_users' prop set to false
            withNonUser: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            editableInputs() {
                return this.withNonUser ? this.inputs : this.inputs.filter(input => !!input.for_users);
            }
        },

        methods: {
            isVisible(input) {
                if (!this.data || !this.data[input.id]) {
                    return;
                }

                if (!input.conditions?.length) {
                    return true;
                }

                return input.conditions.every(condition => {
                    if (!condition.dependent_input_id) {
                        return true;
                    }
                    const dependentInput = this.inputs.find(input => input.id === condition.dependent_input_id);
                    if (!dependentInput || !this.isVisible(dependentInput)) {
                        return false;
                    }

                    const userInputValue = this.data[dependentInput.id].value;
                    if (condition.dependent_input_value === null) {
                        return userInputValue !== null && (!isString(userInputValue) || userInputValue.length);
                    }

                    const isSelect = dependentInput.type.value === 'select';
                    if (isSelect) {
                        const selectedUserOption = dependentInput.options.find(option => option.text === userInputValue);
                        return selectedUserOption && selectedUserOption.id === parseInt(condition.dependent_input_value);
                    }

                    return parseForInputType(dependentInput.type, userInputValue) === parseForInputType(dependentInput.type, condition.dependent_input_value);
                });
            }
        }
    }
</script>
